var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "payt-carousel-container" },
      [
        _vm.videoCode
          ? _c("div", { staticClass: "payt-carousel-item" }, [
              _c("div", { staticClass: "ratio ratio-16x9" }, [
                _c("div", {
                  attrs: {
                    id: "vitrine-desktop-video-player",
                    "data-video-id": _vm.videoCode,
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.fotosParsed, function (foto, i) {
          return _c("div", { key: i, staticClass: "payt-carousel-item" }, [
            _c("img", {
              staticClass: "w-100",
              attrs: { src: foto, alt: "Imagem de vitrine" },
            }),
          ])
        }),
      ],
      2
    ),
    _vm._v(" "),
    _vm.nItens > 0
      ? _c("div", { staticClass: "payt-carousel-preview-container" }, [
          _vm.nItens > 5
            ? _c(
                "div",
                {
                  staticClass: "payt-carousel-control-left",
                  on: { click: _vm.previusPreviewPage },
                },
                [_c("i", { staticClass: "fa-solid fa-angle-left" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "payt-carousel-preview-icons-container" },
            [
              _vm.videoCode
                ? _c(
                    "div",
                    {
                      staticClass: "payt-carousel-preview-item",
                      attrs: { "data-index": "0" },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "https://img.youtube.com/vi/" +
                            _vm.videoCode +
                            "/hqdefault.jpg",
                          alt: "Preview de vídeo da vitrine",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.fotosParsed, function (foto, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "payt-carousel-preview-item",
                    attrs: { "data-index": i + (_vm.videoCode ? 1 : 0) },
                  },
                  [
                    _c("img", {
                      attrs: { src: foto, alt: "Preview de imagem da vitrine" },
                    }),
                  ]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.nItens > 5
            ? _c(
                "div",
                {
                  staticClass: "payt-carousel-control-right",
                  on: { click: _vm.nextPreviewPage },
                },
                [_c("i", { staticClass: "fa-solid fa-angle-right" })]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }